export default function NewVersionEnabled(store) {
    var user = store.getters["user/user"];
    return user.new_version_enabled == true;
  }
  